import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProfileTabs from "@components/templates/Profile/ProfileTabs/ProfileTabs";
import { getEventName, getUserActivePlan } from "@helpers/profileHelper";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { useLocation, useParams } from "react-router-dom";
import { cachingPanelData, companyEvents, companyTabs, profileTypeEndPoint } from "@containers/CompanyProfile/utils/enum.js";
import { renderCompanyTabs } from "@containers/CompanyProfile/utils/helper";
import axios from "axios";
import { buyerCachingHandler, supplierCachingHandler, tabDetailsHandler } from "@redux/CompanyProfile/companyProfileSlice";
import { profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { toast } from "react-toastify";

const Tabs = ({ isSalesForce, handlePanelClick }) => {
  const { companyID, companyname } = useParams();
  const [profileTabData, setProfileTabData] = useState(companyTabs);
  const [showTabs, setShowTabs] = useState(true);
  const [shipmentDistributionData, setShipmentDistributionData] = useState([]);
  const [viewShipmentClick, setViewShipmentClick] = useState(false);
  const [shipmentDistributionLoader, setShipmentDistributionLoader] = useState(false);
  const { tabDetails } = useSelector((state) => state.companyProfile);
  const { search: searchUrlParams, pathname } = useLocation();
  const mergedID = new URLSearchParams(searchUrlParams).get("mergedID");

  const {
    isParentSubs,
    countDetails,
    buyerCaching,
    supplierCaching,
    tabDetails: { activePanelId, activeTabId },
  } = useSelector((state) => state.companyProfile);
  const { loading } = countDetails;
  const dispatch = useDispatch();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");

  useEffect(() => {
    const filteredTabs = [];
    let tabsData = tabDetails?.activeTab?.length ? tabDetails?.activeTab : companyTabs;
    tabsData.map((tab) => {
      if ((tab.countEnum && countDetails[tab.countEnum] > 0) || tab.isExcludeFilter || tab.id === activeTabId || (showTabs && tabDetails?.activePanelId === cachingPanelData.logistic_partners)) {
        filteredTabs.push({ ...tab, count: countDetails[tab.countEnum] });
      }
    });
    setProfileTabData(filteredTabs);
  }, [countDetails, tabDetails, isParentSubs, showTabs]);

  const handleTabClick = (id) => {
    trademoTrackingEvents(getEventName(profileTypeEnum.company, companyEvents[id]?.tab ? companyEvents[id]?.tab : id), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    dispatch(
      tabDetailsHandler({
        ...tabDetails,
        activeTabId: id,
      })
    );
  };

  const fetchShipmentData = async () => {
    try {
      setShipmentDistributionLoader(true);
      const requestPayload = {
        profile_type: profileTypeEnum.company,
        _id: companyID,
        category: activePanelId,
        sub_category: activeTabId,
        slug: companyname,
        isSubsidiaryIncluded: isParentSubs,
      };
      if (mergedID) {
        requestPayload.isMerged = true;
        requestPayload.mergedID = +mergedID;
      }

      const res = await axios.post(profileTypeEndPoint.getShipmentDistribution, requestPayload);
      const { data } = res.data;
      if (data && Array.isArray(data)) {
        setShipmentDistributionData(data);
        if (cachingPanelData.importers === activePanelId) {
          let buyerCachingClone = JSON.parse(JSON.stringify(buyerCaching));
          buyerCachingClone.shipmentDistribution = data;
          dispatch(buyerCachingHandler(buyerCachingClone));
        } else if (cachingPanelData.exporters === activePanelId) {
          let supplierCachingClone = JSON.parse(JSON.stringify(supplierCaching));
          supplierCachingClone.shipmentDistribution = data;
          dispatch(supplierCachingHandler(supplierCachingClone));
        }
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again later !!!");
    } finally {
      setShipmentDistributionLoader(false);
    }
  };
  useLayoutEffect(() => {
    setShipmentDistributionLoader(true);
    if (activePanelId === cachingPanelData.importers || activePanelId === cachingPanelData.exporters) {
      if (cachingPanelData.importers === activePanelId && buyerCaching.shipmentDistribution) {
        let buyerCachingClone = JSON.parse(JSON.stringify(buyerCaching));
        setShipmentDistributionData(buyerCachingClone.shipmentDistribution);
        setShipmentDistributionLoader(false);
      } else if (cachingPanelData.exporters === activePanelId && supplierCaching.shipmentDistribution) {
        let supplierCachingClone = JSON.parse(JSON.stringify(supplierCaching));
        setShipmentDistributionData(supplierCachingClone.shipmentDistribution);
        setShipmentDistributionLoader(false);
      } else if (viewShipmentClick) {
        setShipmentDistributionData([]);
        fetchShipmentData();
      }
    }
  }, [activeTabId, isParentSubs, activePanelId, viewShipmentClick]);

  return profileTabData && profileTabData.length >= 0 ? (
    <>
      {showTabs && <ProfileTabs handleTabClick={handleTabClick} activeTabId={activeTabId} loading={loading} profileTabData={profileTabData} shipmentDistributionData={shipmentDistributionData} isSalesForce={isSalesForce} setViewShipmentClick={setViewShipmentClick} viewShipmentClick={viewShipmentClick} setShipmentDistributionLoader={setShipmentDistributionLoader} shipmentDistributionLoader={shipmentDistributionLoader} />}
      {renderCompanyTabs(activeTabId, setShowTabs, shipmentDistributionData, setShipmentDistributionData, isSalesForce, viewShipmentClick, setViewShipmentClick, shipmentDistributionLoader, setShipmentDistributionLoader, handlePanelClick, activePanelId)}
    </>
  ) : null;
};

export default Tabs;
